export default __webpack_public_path__ + "media/images/react_icons/headphones-390bc26a665f2bae48679db53df6d9d8.svg";